import { css } from "styled-components";
import { BladeHeaderTitle } from "../../../../components/BladeHeaderTitle";
import { riotProductSkin } from "../riot-product";
export const riotProductLionSkin = (chroma, paletteTokens) => css `
  ${riotProductSkin(chroma, paletteTokens)}

  ${BladeHeaderTitle} {
    h2 {
      &::after {
        content: "";
        display: block;
        height: 27px;
        width: 192px;
        margin-top: 20px;
        background: repeating-linear-gradient(
          45deg,
          ${paletteTokens.accents1},
          ${paletteTokens.accents1} 5px,
          transparent 5px,
          transparent 10px
        );
        ${chroma.mediaQueries.tabletDown} {
          width: 115px;
          height: 17px;
        }
        ${chroma.mediaQueries.mobileDown} {
          width: 50%;
        }
      }
    }
  }
`;
//# sourceMappingURL=index.js.map